import React from 'react';
import { Phone, AlertTriangle, CheckCircle, HelpCircle, FileText, Scale } from 'lucide-react';
export function MichiganDotInspectionPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5589">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-5590">
        <div className="container mx-auto px-4" data-id="element-5591">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-5592">
            Michigan DOT Inspection
          </h1>
          <p className="text-2xl text-gray-100 text-center font-bold" data-id="element-5593">
            DO I NEED A DOT INSPECTION?
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-5594">
        <div className="max-w-4xl mx-auto" data-id="element-5595">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5596">
            <p className="text-lg text-gray-700 mb-6" data-id="element-5597">
              Do you need a DOT inspection in Michigan? The answer depends on a
              variety of factors. We break it down here on our Michigan DOT
              Inspection page.
            </p>

            <p className="text-lg text-gray-700 mb-4" data-id="element-5598">
              Garrett Auto & Truck Service offers Michigan Department of
              Transportation (MDOT) inspections for all qualifying commercial
              vehicles and trailers, ensuring safe and legal operations across
              Southeast Michigan.
            </p>

            <p className="text-lg text-gray-700" data-id="element-5599">
              The Michigan Department of Transportation requires all commercial
              vehicles to be inspected annually if they meet these requirements.
            </p>
          </div>

          {/* Need Help CTA */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-6 mb-8 text-center" data-id="element-5600">
            <p className="text-xl" data-id="element-5601">
              <strong className="text-red-600" data-id="element-5602">
                I DONT HAVE TIME TO READ THIS
              </strong>{' '}
              <a href="/contact" className="text-blue-600 hover:underline font-bold italic" data-id="element-5603">
                Click Here
              </a>{' '}
              <strong className="text-red-600" data-id="element-5604">FOR HELP</strong>
            </p>
          </div>

          {/* DOT Information */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5605">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5606">
              DOT Information For Commercial & Company Vehicles
            </h2>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6" data-id="element-5607">
              <p className="text-lg text-gray-700" data-id="element-5608">
                If your vehicle and trailer exceed 10,000 lbs, you will need DOT
                inspection performed on both. All trailers must be DOT
                inspected.
              </p>
            </div>

            <div className="space-y-4 mb-6" data-id="element-5609">
              <div className="bg-green-50 rounded-lg p-4" data-id="element-5610">
                <p className="text-gray-800" data-id="element-5611">
                  <strong data-id="element-5612">Trailers under 15,000 lbs:</strong> Only requires
                  brake system on single axle of twin axle trailers
                </p>
              </div>

              <div className="bg-yellow-50 rounded-lg p-4" data-id="element-5613">
                <p className="text-gray-800" data-id="element-5614">
                  <strong data-id="element-5615">Trailers over 15,000 lbs:</strong> Will need brakes on
                  both axles
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-6" data-id="element-5616">
              <p className="text-gray-700 mb-4" data-id="element-5617">
                This is a basic explanation of DOT regulations. If more detailed
                information is needed, please contact DOT or give us a call if
                you want to set up a DOT inspection.
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-5618">
                <li data-id="element-5619">
                  * DOT annual inspection stickers are separate from the actual
                  DOT numbers found on the side of commercial vehicles
                </li>
                <li data-id="element-5620">
                  * Phone number to DOT:{' '}
                  <a href="tel:18006824682" className="text-blue-600 hover:underline" data-id="element-5621">
                    1-800-682-4682
                  </a>
                </li>
                <li data-id="element-5622">
                  * Link to DOT website -{' '}
                  <a href="https://www.fmcsa.dot.gov/regulations" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-5623">
                    DOT Website
                  </a>
                </li>
                <li data-id="element-5624">
                  * Link to -{' '}
                  <a href="https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/docs/part-396form6.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-5625">
                    DOT Inspection Form
                  </a>
                </li>
                <li data-id="element-5626">
                  * Link to Federal DOT website for the long Federal over the
                  road numbers -{' '}
                  <a href="https://www.transportation.gov/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-5627">
                    Federal DOT website
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Limousine Inspections */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5628">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5629">
              Limousine Inspections
            </h2>
            <p className="text-lg text-gray-700 mb-4" data-id="element-5630">
              Each limousine must have an annual safety inspection conducted by
              a currently certified mechanic at a registered repair facility on
              an MDOT form 3049 or 3049E.
            </p>
            <div className="bg-purple-50 border-l-4 border-purple-500 p-4" data-id="element-5631">
              <p className="text-gray-800" data-id="element-5632">
                Limousine inspections must be performed on all vehicles hauling{' '}
                <strong data-id="element-5633">15 passengers or less including driver</strong>.
              </p>
            </div>
          </div>

          {/* Weight Definitions */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5634">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-5635">
              <Scale className="mr-3 text-[#B1050B]" size={28} data-id="element-5636" />
              Weight Definitions & Calculations
            </h2>

            <div className="space-y-4" data-id="element-5637">
              <div className="bg-blue-50 rounded-lg p-4" data-id="element-5638">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5639">
                  Gross Combination Weight (GCW)
                </h3>
                <p className="text-gray-700" data-id="element-5640">
                  Total weight of a fully equipped truck and trailer with cargo,
                  driver, and passengers, fuel, coolant, equipment, etc.
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-4" data-id="element-5641">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5642">
                  Gross Combination Weight Rating (GCWR)
                </h3>
                <p className="text-gray-700" data-id="element-5643">
                  Maximum allowable gross combination weight (GCW)
                </p>
              </div>

              <div className="bg-yellow-50 rounded-lg p-4" data-id="element-5644">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5645">
                  Gross Trailer Weight (GTW)
                </h3>
                <p className="text-gray-700" data-id="element-5646">
                  The weight of the trailer plus all the cargo in it. This is
                  measured by putting a fully loaded trailer on a scale.
                </p>
              </div>

              <div className="bg-purple-50 rounded-lg p-4" data-id="element-5647">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5648">
                  Gross Trailer Weight Rating (GTWR)
                </h3>
                <p className="text-gray-700" data-id="element-5649">
                  Maximum allowable weight of the trailer, plus its cargo.
                </p>
              </div>

              <div className="bg-red-50 rounded-lg p-4" data-id="element-5650">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5651">
                  Gross Vehicle Weight (GVW)
                </h3>
                <p className="text-gray-700" data-id="element-5652">
                  The total weight of the tow vehicle, including driver,
                  passengers, and any special equipment (options, accessories
                  and upfitted equipment), cargo, fuel, coolant, etc.
                </p>
              </div>

              <div className="bg-indigo-50 rounded-lg p-4" data-id="element-5653">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-5654">
                  Gross Vehicle Weight Rating (GVWR)
                </h3>
                <p className="text-gray-700" data-id="element-5655">
                  The maximum allowable total weight of the tow vehicle,
                  including driver, passengers, any special equipment (options,
                  accessories and upfitted equipment), cargo, fuel, coolant,
                  etc.
                </p>
              </div>
            </div>
          </div>

          {/* Quick Recap */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-5656">
            <h2 className="text-3xl font-bold mb-6" data-id="element-5657">Quick Recap</h2>

            <h3 className="text-2xl font-bold mb-4" data-id="element-5658">
              Who Needs a DOT Inspection?
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-5659">
              <li className="flex items-start" data-id="element-5660">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5661" />
                <span data-id="element-5662">
                  If your vehicle or trailer exceeds 10,000 lbs (GVW or GCW),
                  both require MDOT inspection
                </span>
              </li>
              <li className="flex items-start" data-id="element-5663">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5664" />
                <span data-id="element-5665">
                  Trailers under 15,000 lbs need inspection of the brake system
                  on a single-axle or twin-axle configuration
                </span>
              </li>
              <li className="flex items-start" data-id="element-5666">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5667" />
                <span data-id="element-5668">
                  Trailers over 15,000 lbs require brake inspections on both
                  axles
                </span>
              </li>
            </ul>

            <p className="text-gray-200" data-id="element-5669">
              Stickers from annual inspections are separate from DOT numbers
              displayed on your vehicle body.
            </p>
          </div>

          {/* Why Choose Garrett Auto */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5670">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-5671">
              Why Choose Garrett Auto for Your DOT Inspection?
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-5672">
              <div className="text-center" data-id="element-5673">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5674">
                  <CheckCircle className="text-blue-600" size={32} data-id="element-5675" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5676">
                  Certified Technicians
                </h3>
                <p className="text-gray-700" data-id="element-5677">
                  Deep expertise in MDOT protocols
                </p>
              </div>

              <div className="text-center" data-id="element-5678">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5679">
                  <FileText className="text-green-600" size={32} data-id="element-5680" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5681">
                  Convenient Location
                </h3>
                <p className="text-gray-700" data-id="element-5682">
                  Farmington Hills, serving Brighton, Novi, Livonia, Commerce,
                  and nearby areas
                </p>
              </div>

              <div className="text-center" data-id="element-5683">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5684">
                  <AlertTriangle className="text-purple-600" size={32} data-id="element-5685" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5686">
                  Fast & Reliable
                </h3>
                <p className="text-gray-700" data-id="element-5687">
                  Minimize downtime for your fleet
                </p>
              </div>
            </div>

            <p className="text-center text-gray-700 mt-6" data-id="element-5688">
              Need clarification on regulations or assistance interpreting DOT
              forms? We've got your back.
            </p>
          </div>

          {/* What is a CMV */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5689">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-5690">
              What is a Commercial Motor Vehicle (CMV)?
            </h2>

            <p className="text-lg text-gray-700 mb-4" data-id="element-5691">
              You are operating a commercial motor vehicle if you transport
              passengers or property in a vehicle that:
            </p>

            <div className="space-y-4" data-id="element-5692">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-5693">
                <p className="text-gray-800 mb-2" data-id="element-5694">
                  <strong data-id="element-5695">
                    Has an actual gross vehicle weight (GVW) or gross
                    combination vehicle weight (GCW) of 10,001 pounds or more
                  </strong>
                </p>
                <ul className="ml-4 space-y-1 text-gray-700" data-id="element-5696">
                  <li data-id="element-5697">• GVW means the weight of a vehicle and its load</li>
                  <li data-id="element-5698">
                    • GCW means the weight of a combination vehicle and its load
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-5699">
                <p className="text-gray-800 mb-2" data-id="element-5700">
                  <strong data-id="element-5701">
                    Has a gross vehicle weight rating (GVWR) or gross
                    combination weight rating (GCWR) of 10,001 pounds or more
                  </strong>
                </p>
                <ul className="ml-4 space-y-1 text-gray-700" data-id="element-5702">
                  <li data-id="element-5703">
                    • GVWR is the value specified by the manufacturer as a safe
                    loaded weight of a single vehicle (the GVWR is located on
                    the manufacturer's tag, usually found inside the driver's
                    side door)
                  </li>
                  <li data-id="element-5704">
                    • GCWR is the value specified by the manufacturer as the
                    loaded weight of a combination of vehicles
                  </li>
                  <li data-id="element-5705">
                    • As used here, a combination vehicle means a truck pulling
                    another vehicle or trailer
                  </li>
                </ul>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-5706">
                <ul className="space-y-1 text-gray-700" data-id="element-5707">
                  <li data-id="element-5708">
                    • Is designed or used to carry 16 or more passengers,
                    including the driver
                  </li>
                  <li data-id="element-5709">
                    • Is transporting hazardous materials (in amounts that
                    require placarding)
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* It Does Not Matter */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-5710">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-5711">
              IT does not matter if you:
            </h3>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-6" data-id="element-5712">
              <li data-id="element-5713">Are not for-hire</li>
              <li data-id="element-5714">Only transport company property</li>
              <li data-id="element-5715">Are the owner or only driver</li>
            </ol>

            <p className="text-gray-800 mb-4" data-id="element-5716">
              <strong data-id="element-5717">
                If your vehicle meets the criteria for a commercial motor
                vehicle, the following rules, regulations and laws may apply to
                the company, the vehicle and all drivers:
              </strong>
            </p>

            <ul className="space-y-2 text-gray-700" data-id="element-5718">
              <li className="flex items-start" data-id="element-5719">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5720" />
                <span data-id="element-5721">Chauffeur Driver License</span>
              </li>
              <li className="flex items-start" data-id="element-5722">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5723" />
                <span data-id="element-5724">Commercial Driver License (CDL)</span>
              </li>
              <li className="flex items-start" data-id="element-5725">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5726" />
                <span data-id="element-5727">
                  Driver Qualifications (i.e., medical cards, driver files,
                  state driving record)
                </span>
              </li>
              <li className="flex items-start" data-id="element-5728">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5729" />
                <span data-id="element-5730">Driver Drug and Alcohol Testing</span>
              </li>
              <li className="flex items-start" data-id="element-5731">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5732" />
                <span data-id="element-5733">Hours of Service</span>
              </li>
              <li className="flex items-start" data-id="element-5734">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5735" />
                <span data-id="element-5736">Log Books</span>
              </li>
              <li className="flex items-start" data-id="element-5737">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5738" />
                <span data-id="element-5739">
                  Hazardous Material Regulations (applies to gasoline, oxygen,
                  acetylene, fertilizer or other hazardous materials, regardless
                  of the amount you carry)
                </span>
              </li>
              <li className="flex items-start" data-id="element-5740">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5741" />
                <span data-id="element-5742">
                  Vehicle Equipment Compliance (required equipment, daily and
                  annual inspection reports, cargo securement)
                </span>
              </li>
              <li className="flex items-start" data-id="element-5743">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5744" />
                <span data-id="element-5745">Size and Weight (pertains to all vehicles)</span>
              </li>
              <li className="flex items-start" data-id="element-5746">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5747" />
                <span data-id="element-5748">Fuel Tax and IRP Registration</span>
              </li>
              <li className="flex items-start" data-id="element-5749">
                <CheckCircle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5750" />
                <span data-id="element-5751">Minimum Amounts of Insurance</span>
              </li>
            </ul>
          </div>

          {/* FAQ Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5752">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-5753">
              <HelpCircle className="mr-3 text-blue-600" size={28} data-id="element-5754" />
              F.A.Q. Section
            </h2>

            <div className="space-y-6" data-id="element-5755">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-5756">
                <p className="font-bold text-gray-900 mb-2" data-id="element-5757">
                  Q: Are limousines inspected?
                </p>
                <p className="text-gray-700" data-id="element-5758">
                  A: Yes. Vehicles carrying 15 passengers (including the driver)
                  require annual MDOT inspections using form 3049 or 3049E
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-5759">
                <p className="font-bold text-gray-900 mb-2" data-id="element-5760">
                  Q: What weights qualify as a commercial motor vehicle (CMV)?
                </p>
                <p className="text-gray-700" data-id="element-5761">
                  A: Any vehicle combination with a GVW or GCW over 10,001 lbs,
                  those transporting passengers, or hazardous materials may be
                  subject to CMV regulations.
                </p>
              </div>
            </div>
          </div>

          {/* Compliance Quiz */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5762">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5763">
              Take this simple compliance indicator quiz!
            </h2>

            <div className="space-y-6" data-id="element-5764">
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-5765">
                <p className="text-lg text-gray-800 mb-2" data-id="element-5766">
                  Do you use a small truck (box van, step van), a pickup towing
                  a trailer or a small bus in your business?
                </p>
                <p className="text-gray-600" data-id="element-5767">☐ Yes ☐ No</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6" data-id="element-5768">
                <p className="text-lg text-gray-800 mb-3" data-id="element-5769">
                  Is your vehicle used to transport:
                </p>
                <ul className="space-y-1 text-gray-700 mb-3" data-id="element-5770">
                  <li data-id="element-5771">• A product</li>
                  <li data-id="element-5772">• Passengers</li>
                  <li data-id="element-5773">• Tools and/or supplies used in your trade</li>
                  <li data-id="element-5774">
                    • Any amount of a hazardous material (gasoline, oxygen,
                    acetylene, propane, paint, solvents, glues, fertilizer,
                    etc.)
                  </li>
                </ul>
                <p className="text-gray-600" data-id="element-5775">☐ Yes ☐ No</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-6" data-id="element-5776">
                <p className="text-lg text-gray-800 mb-2" data-id="element-5777">
                  Do you personally own, lease or use your employee's vehicles
                  in your business?
                </p>
                <p className="text-gray-600" data-id="element-5778">☐ Yes ☐ No</p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6" data-id="element-5779">
                <p className="text-gray-800 mb-4" data-id="element-5780">
                  <strong data-id="element-5781">
                    If you answered yes to one or more of these questions, some
                    or all of the federal and state safety regulations may apply
                    to your company, your vehicles and the people who drive
                    them.
                  </strong>
                </p>
                <p className="text-gray-700" data-id="element-5782">
                  State and local enforcement agencies understand and enforce
                  these regulations. It is important that you understand them as
                  well. Violations are subject to both civil and criminal
                  penalties.
                </p>
              </div>
            </div>
          </div>

          {/* Final CTA */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-5783">
            <h2 className="text-3xl font-bold mb-4" data-id="element-5784">
              Ready to Schedule Your DOT Inspection?
            </h2>
            <p className="text-xl mb-6" data-id="element-5785">
              Ensure your commercial vehicles are road-legal and
              compliant—without the hassle
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-5786">
              <Phone className="mr-3" size={24} data-id="element-5787" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-5788">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}